import React, { useState, useEffect, useRef } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { X, Building } from 'lucide-react';

import { useRecoilState } from 'recoil';
import { outletAtom, subAtom, paramsAtom } from 'core/config/atoms';

import Lottie from 'lottie-react';
import { toast } from 'react-toastify';

import ServiceMenu from 'services/serviceMenu';
import ServiceFloor from 'services/serviceFloor';
import ServiceOrder from 'services/serviceOrder';
import ServiceRental from 'services/serviceRental';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';

import DigItemOption from 'core/widgets/ui/dailogs/DigItemOption';
import DigItemCart from 'core/widgets/ui/dailogs/DigItemCart';
import ServiceCRM from 'services/serviceCRM';
import ServiceOutlet from 'services/serviceOutlet';

export default function SubPanelB(props) {

    const [outlet] = useRecoilState(outletAtom);
    const [sub] = useRecoilState(subAtom);
    const [param, setParam] = useRecoilState(paramsAtom);

    const searchARef = useRef('');
    const searchBRef = useRef('');
    const fieldCRef = useRef('');
    const fieldDRef = useRef('');
    const fieldERef = useRef('');

    const fieldPhone = useRef('');
    const fieldName = useRef('');
    const fieldEmail = useRef('');

    const [table, setTable] = useState(undefined);

    const [menus, setMenus] = useState([]);
    const [menusFilter, setMenusFilter] = useState([]);
    const [cats, setCats] = useState([]);
    const [ordItems, setOrdItems] = useState([]);
    const [orders, setOrders] = useState([]);
    const [selOrdIds, setSelOrdIds] = useState([]);

    const [rents, setRents] = useState([]);
    const [isRentOpen, setIsRentOpen] = useState(false);
    const [selRent, setSelRent] = useState({});

    const [activeRents, setActiveRents] = useState([]);
    const [isActiveRentOpen, setIsActiveRentOpen] = useState(false);

    const [selItem, setSelItem] = useState({});
    const [taxSetting, setTax] = useState({});
    const [invoice, setInvoice] = useState({});
    const [cust, setCust] = useState({
        'type': 'empty',
        'name': '',
        'phone': '',
        'email': '',
    });

    const [selCat, setSelCat] = useState('all');
    const [terminal, setTerminal] = useState('order');
    const [selOrd, setSelOrd] = useState('');
    const [pmode, setPMode] = useState('cash');
    const [dmode, setDMode] = useState('A');

    const [schrge, setSchrge] = useState(0);
    const [discount, setDiscount] = useState(0);

    const [isOptionOpen, setIsOptionOpen] = useState(false);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isQSR, setQSR] = useState(false);

    const menuService = new ServiceMenu();
    const floorService = new ServiceFloor();
    const orderService = new ServiceOrder();
    const crmService = new ServiceCRM();
    const outletService = new ServiceOutlet();
    const rentalService = new ServiceRental();

    const gotoBack = () => {
        setParam({});
        props.changePanel('A');
    }

    const sortTable = (filter) => {
        setSelCat(filter);
        if (filter === 'all') {
            setMenusFilter(menus);
        } else {
            let tempList = menus.filter((item) => item.category === filter);
            setMenusFilter(tempList);
        }
    }

    const handleChangeForm = (target) => {
        switch (target) {
            case "itemSearch":
                const queryA = searchARef.current.value;
                let tempListA = menus.filter((item) => item.name.toLowerCase().includes(queryA.toLowerCase()));
                setMenusFilter(tempListA);
                break;
            case "itemCode":
                const queryB = searchBRef.current.value;
                let tempListB = menus.filter((item) => item.shortCode.toLowerCase().includes(queryB.toLowerCase()));
                setMenusFilter(tempListB);
                break;
            case "itemService":
                setSchrge(fieldCRef.current.value);
                break;
            case "itemDiscount":
                setDiscount(fieldERef.current.value);
                break;
            case "custPhone":
                const tempPhone = fieldPhone.current.value;
                setCust({ ...cust, phone: tempPhone });
                if (/^\d{10}$/.test(tempPhone)) {
                    checkCustomer(tempPhone);
                }
                break;
            case "custName":
                setCust({ ...cust, name: fieldName.current.value });
                break;
            case "custEmail":
                setCust({ ...cust, email: fieldEmail.current.value });
                break;
        }
    }

    const getOrderStatus = (sts) => {
        switch (sts) {
            case 'open':
            case 'running':
                return "Running";
            case 'billed':
                return 'Billed';
            default:
                return "NA";
        }
    }

    const getPType = () => {
        switch (param.type) {
            case 'takeaway':
                return "Take-Away Order";
            case 'delivery':
                return "Delivery Order";
            default:
                return "NA";
        }
    }

    const addItem = (item) => {
        if (!isQSR) {
            if (terminal !== "order" && terminal !== "update") {
                return;
            }
        }
        if (sub.apps.includes("APP00004") && item.isRental === true) {
            (async function () {
                let body = { 'filter': { 'type': item.rental, 'status': 'none' } };
                var res = await rentalService.getAllRental(body);
                if (res.status) {
                    setRents(res.data.data);
                    setSelItem(item);
                    setIsRentOpen(true);
                }
            })();
            return;
        }
        let isItem = ordItems.findIndex((a) => a.id === item._id);
        if (item["hasVariants"] || item["addons"].length != 0) {
            if (isItem === -1) {
                setSelItem(item);
                setIsOptionOpen(true);
            } else {
                setSelItem(item);
                setIsCartOpen(true);
            }
        } else {
            let tempList = [...ordItems];
            if (isItem === -1) {
                let ordItem = {
                    id: item._id,
                    menuid: item.menuid,
                    name: item.name,
                    shortCode: item.shortCode,
                    category: item.category,
                    price: item.basePrice,
                    tax: item.taxPercentage,
                    qty: 1,
                    itemtype: "base",
                    status: 'none'
                };
                tempList.push(ordItem);
            } else {
                tempList[isItem].qty = tempList[isItem].qty + 1;
            }
            setOrdItems(tempList);
        }
    }

    const onClose = (item) => {
        if (item === null) {
            setIsOptionOpen(false);
            setSelItem({});
        } else {
            let tempList = [...ordItems];
            tempList.push(item);
            setOrdItems(tempList);
            setIsOptionOpen(false);
            setSelItem({});
        }
    }

    const addRentalToCart = () => {
        let tempList = [...ordItems];
        let ordItem = {
            id: selItem._id,
            menuid: selItem.menuid,
            name: `${selItem.name} - ${selRent.title}`,
            shortCode: selItem.shortCode,
            category: selItem.category,
            price: selItem.basePrice,
            tax: selItem.taxPercentage,
            qty: 1,
            itemtype: "base",
            status: 'none',
            isRental: true,
            ref: { 'id': selRent._id, 'title': selRent.title }
        };
        tempList.push(ordItem);
        setOrdItems(tempList);
        setSelItem({});
        setIsRentOpen(false);
        setRents([]);
        setSelRent({});
    }

    const loadActiveRentals = () => {
        (async function () {
            let body = { 'filter': { 'status': 'active' } };
            var res = await rentalService.getAllRental(body);
            if (res.status) {
                setActiveRents(res.data.data);
                setIsActiveRentOpen(true);
            }
        })();
    }

    const releaseRental = (item) => {
        (async function () {
            let body = { 'uid': item._id, 'data': { 'status': 'none' } };
            var res = await rentalService.updateRental(body);
            if (res.status) {
                toast.success("Rental released!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                setIsActiveRentOpen(false);
                setActiveRents([]);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const onCartClose = (item) => {
        if (item === null) {
            setIsCartOpen(false);
            setSelItem({});
        } else {
            if (item.action === "addnew") {
                setIsCartOpen(false);
                setIsOptionOpen(true);
            } else {
                setOrdItems(item.data);
            }
        }
    }

    const removeQty = (item) => {
        if (!isQSR) {
            if (terminal !== "order" && terminal !== "update") {
                return;
            }
        }
        let isItem = ordItems.findIndex((a) => a.id === item.id);
        if (isItem !== -1) {
            let tempList = [...ordItems];
            let tempItem = tempList[isItem];
            if (tempItem["itemtype"] !== "base") {
                setSelItem(item);
                setIsCartOpen(true);
            } else {
                tempList[isItem].qty = tempList[isItem].qty - 1;
                setOrdItems(tempList);
            }
        }
    }

    const removeItem = (item) => {
        if (!isQSR) {
            if (terminal !== "order" && terminal !== "update") {
                return;
            }
        }
        let isItem = ordItems.findIndex((a) => a.id === item.id);
        if (isItem !== -1) {
            let tempList = [...ordItems];
            let tempItem = tempList[isItem];
            if (tempItem["itemtype"] !== "base") {
                setSelItem(item);
                setIsCartOpen(true);
            } else {
                tempList.splice(isItem, 1);
                setOrdItems(tempList);
            }
        }
    }

    const addQty = (item) => {
        if (!isQSR) {
            if (terminal !== "order" && terminal !== "update") {
                return;
            }
        }
        if (item.isRental) {
            return;
        }
        let isItem = ordItems.findIndex((a) => a.id === item.id);
        if (isItem !== -1) {
            let tempList = [...ordItems];
            let tempItem = tempList[isItem];
            if (tempItem["itemtype"] !== "base") {
                setSelItem(item);
                setIsCartOpen(true);
            } else {
                tempList[isItem].qty = tempList[isItem].qty + 1;
                setOrdItems(tempList);
            }
        }
    }

    const getTotal = () => {
        let total = 0;
        ordItems.forEach((a) => {
            total = total + (a.price * a.qty);
        });
        return total;
    }

    const getDiscount = () => {
        let dis = 0;
        if (parseFloat(discount) !== 0) {
            if (dmode === "A") {
                dis = parseFloat(discount)
            } else {
                dis = getTotal() * (parseFloat(discount) / 100);
            }
        }
        return dis;
    }

    const getTax = () => {
        let total = getTotal();
        let dis = getDiscount();
        const taxableValue = total - dis;
        let tax = 0;
        if (Object.keys(taxSetting).length !== 0) {
            switch (taxSetting.Food_TAX_TYPE) {
                case "na":
                    tax = 0;
                    break;
                case "inclusive":
                    if (taxSetting.Food_Percentage > 0) {
                        tax =
                            taxableValue -
                            taxableValue / (1 + taxSetting.Food_Percentage / 100);
                    }
                    break;
                case "exclusive":
                    tax = taxableValue * (taxSetting.Food_Percentage / 100);
                    break;
                case "overall":
                    tax = ordItems.reduce((acc, item) => {
                        const itemValue = item.price * item.qty;
                        const itemTaxRate = item.tax || 0;
                        return acc + itemValue * (itemTaxRate / 100);
                    }, 0);
                    break;
                default:
                    tax = 0;
                    break;
            }
        }
        const precision = taxSetting.floatingPoint || 2;
        return parseFloat(tax.toFixed(precision));
    }

    const getRoundOff = () => {
        let finalTotal = 0;
        if (Object.keys(taxSetting).length !== 0) {
            const foodType = taxSetting.Food_TAX_TYPE.toLowerCase() ?? "na";
            if (foodType === "inclusive") {
                finalTotal = (getTotal() - getDiscount()) + parseFloat(schrge);
            } else {
                finalTotal = (getTotal() - getDiscount()) + getTax() + parseFloat(schrge);
            }
        } else {
            finalTotal = (getTotal() - getDiscount()) + parseFloat(schrge);
        }
        const roundedTotal = Math.round(finalTotal);
        const roundOffValue = (roundedTotal - finalTotal).toFixed(2);
        if (roundOffValue === "0.00") {
            return roundOffValue;
        }
        return roundOffValue > 0 ? `+${roundOffValue}` : roundOffValue;
    }

    function getFinalTotal() {
        let finalTotal = 0;
        if (Object.keys(taxSetting).length !== 0) {
            const foodType = taxSetting.Food_TAX_TYPE.toLowerCase() ?? "na";
            if (foodType === "inclusive") {
                finalTotal = (getTotal() - getDiscount()) + parseFloat(schrge);
            } else {
                finalTotal = (getTotal() - getDiscount()) + getTax() + parseFloat(schrge);
            }
        } else {
            finalTotal = (getTotal() - getDiscount()) + parseFloat(schrge);
        }
        const roundedTotal = Math.round(finalTotal);
        return roundedTotal;
    }

    const placeOrder = () => {
        if (terminal === "order") {
            if (ordItems.length === 0) {
                toast.error('Please add an item.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            } else {
                if (outlet.outletid.terminaltype === "standard" || outlet.outletid.terminaltype === "cafe") {
                    setSubmit(true);
                    let body = {
                        outletid: outlet.outletid.id,
                        outlet: outlet.outletid.outletid,
                        items: ordItems,
                        unit: param.id === "" ? null : param.id,
                        subunit: param.index,
                        total: getTotal(),
                        type: param.type,
                    }
                    orderService.createPOSOrder(body, '').then((res) => {
                        if (res.status) {
                            toast.success("New order added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            setSubmit(false);
                            setOrdItems([]);
                            if (param.type === "takeaway") {
                                gotoBack();
                            } else {
                                loadOrder();
                            }
                        } else {
                            toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        }
                    });
                } else {
                    toast.error('Terminal is set to wrong mode.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            }
        }
    }

    const placeBill = () => {
        if (ordItems.length === 0) {
            toast.error('Please add an item.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        } else {
            if (isQSR) {
                setSubmit(true);
                var body = {
                    outletid: outlet.outletid.id,
                    outlet: outlet.outletid.outletid,
                    items: ordItems,
                    total: getTotal(),
                    discount: getDiscount(),
                    dmode: dmode,
                    tax: getTax(),
                    scharge: schrge,
                    grand: getFinalTotal(),
                    type: "dinein",
                    pmode: pmode,
                    pref: "OUTLET",
                    isCust: sub.features.isCrm,
                    cust: cust,
                }
                orderService.createQSRInvoice(body, '').then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        toast.success("New invoice added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        setTerminal("settle");
                        resetTerminal();
                    } else {
                        toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                })
            } else {
                if (terminal === 'bill') {
                    setSubmit(true);
                    let body = {
                        outletid: outlet.outletid.id,
                        outlet: outlet.outletid.outletid,
                        ordIds: selOrdIds,
                        items: ordItems,
                        unit: param.id === "" ? null : param.id,
                        subunit: param.index,
                        total: getTotal(),
                        discount: getDiscount(),
                        dmode: dmode,
                        tax: getTax(),
                        scharge: schrge,
                        grand: getFinalTotal(),
                        type: param.type,
                        isCust: sub.features.isCrm,
                        cust: cust,
                    };
                    orderService.createPOSInvoice(body, '').then((res) => {
                        setSubmit(false);
                        if (res.status) {
                            toast.success("New invoice added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            setOrdItems([]);
                            setSelOrdIds([]);
                            setDMode('A');
                            setDiscount(0);
                            setCust({ 'type': 'new', 'name': '', 'phone': '', 'email': '' });
                            setSchrge(0);
                            setIsOpen(false);
                            setTerminal("order");
                            loadData();
                        } else {
                            toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        }
                    });
                } else {
                    setSubmit(true);
                    let body = {
                        outletid: outlet.outletid.id,
                        outlet: outlet.outletid.outletid,
                        invid: invoice.invid,
                        type: param.type,
                        pmode: pmode,
                        pref: "WEBPOS"
                    }
                    orderService.settlePOSInvoice(body, '').then((res) => {
                        setSubmit(false);
                        if (res.status) {
                            toast.success("Invoice has been settled!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            gotoBack();
                        } else {
                            toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        }
                    });
                }
            }
        }
    }

    const createBill = () => {
        let isBillAll = true;
        let TempList = [];
        let TempItemList = [];
        orders.map((ord) => {
            TempList.push(ord._id);
            if (ord.status !== 'billed') {
                isBillAll = false;
            }
            ord.items.forEach((item) => {
                const existingItem = TempItemList.find((i) => i.id === item.id);
                if (existingItem) {
                    existingItem.qty += item.qty;
                } else {
                    TempItemList.push({ ...item });
                }
            });
        });
        setSelOrdIds(TempList);
        setOrdItems(TempItemList);

        if (isBillAll) {
            let body = {
                unit: param.id,
                subunit: param.index,
                status: "open",
            }
            orderService.getInvoiceWithRef(body, '').then((res) => {
                if (res.status) {
                    setInvoice(res.data);
                    setSchrge(res.data.scharge);
                    setTerminal('settle');
                } else {
                    setTerminal('bill');
                }
            });
        } else {
            setTerminal('bill');
        }
    }

    const selBill = (ord) => {
        setTerminal('update');
        setSelOrdIds([]);
        setSelOrd(ord._id);
        setOrdItems(ord.items);
    }

    const updateOrder = () => {
        if (terminal === "update") {
            if (ordItems.length === 0) {
                toast.error('Please add an item.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            } else {
                setSubmit(true);
                var body = {
                    outletid: outlet.outletid.id,
                    outlet: outlet.outletid.outletid,
                    oldid: selOrd,
                    items: ordItems,
                    unit: param.id,
                    subunit: param.index,
                    total: getTotal(),
                    type: param.type
                }
                orderService.updateOrderWithRef(body, '').then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        toast.success("Order updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        setOrdItems([]);
                        setSelOrd('');
                        if (param.type === 'takeaway') {
                            gotoBack();
                        } else {
                            loadData();
                        }
                    } else {
                        toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            }
        }
    }

    const checkCustomer = (phone) => {
        (async function () {
            let custBody = {
                'phone': phone,
            };
            var custRes = await crmService.checkByPhone(custBody, '');
            if (custRes.data) {
                setCust({ 'type': 'old', 'name': custRes.data.name, 'phone': custRes.data.phone, 'email': custRes.data.email });
            } else {
                setCust({ 'type': 'new', 'name': fieldName.current.value, 'phone': fieldPhone.current.value, 'email': fieldEmail.current.value });
            }
        })();
    }

    const resetTerminal = () => {
        setOrdItems([]);
        setSchrge(0);
        setIsOpen(false);
        setDMode("A");
        setDiscount(0);
        setCust({ 'type': 'new', 'name': '', 'phone': '', 'email': '' });
    }

    const loadOrder = () => {
        (async function () {
            let ordBody = {};
            switch (param.type) {
                case "takeaway":
                    ordBody = {
                        'filter': {
                            'ordid': param.ordID,
                            'type': param.type,
                            'status': { "$in": ['open', 'running', 'billed'] }
                        }
                    };
                    break;
                default:
                    ordBody = {
                        'filter': {
                            'type': param.type,
                            'unit': param.id,
                            'subunit': param.index,
                            'status': { "$in": ['open', 'running', 'billed'] }
                        }
                    };
            }
            var ordRes = await orderService.getAllOrders(ordBody, '');
            if (ordRes.status) {
                setOrders(ordRes.data);
            }
        })();
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": {},
                "page": 1,
                "size": 300,
                "searchQuery": "",
                "startDate": "",
                "endDate": ""
            };
            var res = await menuService.getAllMenus(body);
            if (res['status']) {
                setMenus(res.data.data);
                setMenusFilter(res.data.data);
                let tempCat = [];
                res.data.data.forEach(element => {
                    if (!tempCat.includes(element.category)) {
                        tempCat.push(element.category);
                    }
                });
                setCats(tempCat);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
            if (param.type === 'dinein' || param.type === 'roomservice') {
                let tblBody = { 'tid': param.id };
                var tblRes = await floorService.getFloorById(tblBody, '');
                setTerminal("order");
                setTable(tblRes.data.units[param.index]);
                loadOrder();
            } else if (param.type === 'takeaway') {
                setTerminal("order");
                loadOrder();
            } else {
                if ((outlet.outletid.terminaltype === 'standard' || outlet.outletid.terminaltype === 'cafe')) {
                    setTerminal("order");
                    loadOrder();
                } else {
                    setQSR(true);
                    setTerminal("settle");
                }
            }
            if (sub.features.isTax) {
                var res = await outletService.getOutletById({ 'outletid': outlet.outletid.outletid });
                setTax(res.data.tax);
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[10px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>Bill Genrator</h1>
                                    <div className='w-[28px] h-[28px] border cursor-pointer flex items-center justify-center rounded' onClick={() => {
                                        setDMode('A');
                                        setDiscount(0);
                                        setSchrge(0);
                                        setCust({ 'type': 'new', 'name': '', 'phone': '', 'email': '' });
                                        setIsOpen(false);
                                    }}>
                                        <X size={20} />
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Items Summery
                                    </span>
                                </div>
                                <div className='bg-gray-100 p-2'>
                                    <div className='flex items-center'>
                                        <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                        <div className='flex-grow'></div>
                                        <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                    </div>
                                    <hr className='my-1' />
                                    {
                                        ordItems.length !== 0 && ordItems.map((item, index) => {
                                            return <div className="py-1">
                                                <div className="flex flex-row justify-between items-center">
                                                    <div className="flex flex-row items-center w-[70%]">
                                                        <span className="font-medium text-sm">{item.name}</span>
                                                    </div>
                                                    <div className="font-medium text-sm text-right w-[30%]">
                                                        {item.qty} x ₹ {(item.price * item.qty)}
                                                    </div>
                                                </div>
                                                <hr className='my-1' />
                                            </div>
                                        })
                                    }
                                </div>
                                <div className='h-[2px] bg-gray-600'></div>
                                <div className="w-full mt-2 space-y-1">
                                    <div className="flex justify-between">
                                        <span className="font-medium text-sm">Subtotal</span>
                                        <span className="font-medium text-sm">₹ {getTotal(ordItems).toFixed(2)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-medium">@ Discount</span>
                                        <div className='flex'>
                                            <div className='flex items-center'>
                                                <input id="cash-radio" type="checkbox" onChange={() => { setDMode('P'); }} checked={dmode === "P"} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 checked:bg-red-600" />
                                                <label for="cash-radio" className="ms-2 text-xs font-medium text-gray-900 dark:text-gray-300">Percentage (%)</label>
                                            </div>
                                            <div className='flex items-center ml-2'>
                                                <input id="upi-radio" type="checkbox" onChange={() => { setDMode('A'); }} checked={dmode === "A"} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 checked:bg-red-600" />
                                                <label for="upi-radio" className="ms-2 text-xs font-medium text-gray-900 dark:text-gray-300">Amount (₹)</label>
                                            </div>
                                        </div>
                                        <input type="number" id="itemService" ref={fieldERef} onChange={() => { handleChangeForm('itemDiscount') }} autoComplete="off" className="p-1 block w-[100px] h-8 shadow-inner bg-white text-sm border rounded-md outline-none" value={discount} />
                                    </div>
                                    <hr className='my-2' />
                                    {
                                        sub.features.isTax && <div className="flex justify-between text-sm">
                                            <span className="font-medium">Tax (₹)</span>
                                            <span className="font-medium">₹ {getTax(ordItems).toFixed(2)}</span>
                                        </div>
                                    }
                                    <div className="flex justify-between items-center text-sm">
                                        <span className="font-medium">Service Charge</span>
                                        <span className="font-medium">
                                            <input type="number" id="itemService" ref={fieldCRef} onChange={() => { handleChangeForm('itemService') }} autoComplete="off" className="p-1 block w-[100px] h-8 shadow-inner bg-white text-sm border rounded-md outline-none" value={schrge} />
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center text-sm">
                                        <span className="font-medium">Round off</span>
                                        <span className="font-medium">
                                            <input type="text" readOnly={true} ref={fieldDRef} autoComplete="off" className="p-1 block w-[100px] h-8 shadow-inner bg-white text-sm border rounded-md outline-none" value={ordItems.length === 0 ? "0" : getRoundOff()} />
                                        </span>
                                    </div>
                                    <div className="border-t-2 mt-2 py-2 flex items-center justify-between">
                                        <span className="font-semibold text-lg">Total</span>
                                        <span className="font-bold text-lg">₹ {getFinalTotal()}</span>
                                    </div>
                                </div>
                                {
                                    sub.features.isCrm && <>
                                        <div className='h-[2px] bg-gray-600'></div>
                                        <div className="w-full mt-2 space-y-1">
                                            <div className="flex justify-between items-center text-sm">
                                                <span className="font-medium">Customer Phone</span>
                                                <span className="font-medium">
                                                    <input type="text" id="custPhone" ref={fieldPhone} onChange={() => { handleChangeForm('custPhone') }} autoComplete="off" className="p-1 block w-[200px] h-8 shadow-inner bg-white text-sm border rounded-md outline-none" value={cust.phone} />
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center text-sm">
                                                <span className="font-medium">Customer Name</span>
                                                <span className="font-medium">
                                                    <input type="text" id="custName" ref={fieldName} onChange={() => { handleChangeForm('custName') }} autoComplete="off" className="p-1 block w-[200px] h-8 shadow-inner bg-white text-sm border rounded-md outline-none" value={cust.name} />
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center text-sm">
                                                <span className="font-medium">Customer Email</span>
                                                <span className="font-medium">
                                                    <input type="text" id="custEmail" ref={fieldEmail} onChange={() => { handleChangeForm('custEmail') }} autoComplete="off" className="p-1 block w-[200px] h-8 shadow-inner bg-white text-sm border rounded-md outline-none" value={cust.email} />
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                }
                                <div className='flex mt-4'>
                                    <div className="py-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer flex-grow" onClick={() => { placeBill(); }}>
                                        PLACE BILL
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            {isOptionOpen && <DigItemOption onClose={onClose} status={isOptionOpen} item={selItem} />}
            {isCartOpen && <DigItemCart onClose={onCartClose} status={isCartOpen} ordItems={ordItems} item={selItem} />}
            {
                isRentOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[10px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>Select Unit</h1>
                                    <div className='w-[28px] h-[28px] border cursor-pointer flex items-center justify-center rounded' onClick={() => {
                                        setSelItem({});
                                        setIsRentOpen(false);
                                        setRents([]);
                                        setSelRent({});
                                    }}>
                                        <X size={20} />
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Summery
                                    </span>
                                </div>
                                <div className='bg-gray-100 p-2'>
                                    <div className='w-full grid grid-cols-6 gap-2'>
                                        {
                                            rents.length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                            </div>
                                        }
                                        {
                                            rents.length !== 0 && rents.map((unit, index) => {
                                                return <div className={`h-[44px] p-2 rounded shadow col-span-2 border border-dashed border-gray-400 cursor-pointer hover:shadow-md ${selRent._id === unit._id ? 'bg-green-200' : 'bg-white'}`} key={index} onClick={() => { setSelRent(unit) }}>
                                                    <div className='flex justify-between items-center px-1'>
                                                        <div className='flex items-center'>
                                                            <Building size={18} />
                                                            <p className='text-xl font-medium font-serif ml-2'>{unit.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                                <div className='h-[2px] bg-gray-600'></div>
                                <div className='flex mt-4'>
                                    <div class="py-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer flex-grow" onClick={() => {
                                        addRentalToCart();
                                    }}>
                                        SELECT UNIT
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            {
                isActiveRentOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[10px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>Active Rentals</h1>
                                    <div className='w-[28px] h-[28px] border cursor-pointer flex items-center justify-center rounded' onClick={() => {
                                        setIsActiveRentOpen(false);
                                        setActiveRents([]);
                                    }}>
                                        <X size={20} />
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>List
                                    </span>
                                </div>
                                <div className='bg-gray-100 p-2'>
                                    <div className='w-full grid grid-cols-6 gap-2'>
                                        {
                                            activeRents.length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                <h1 className='text-sm font-medium text-prime'>No active rentals found.</h1>
                                            </div>
                                        }
                                        {
                                            activeRents.length !== 0 && activeRents.map((unit, index) => {
                                                return <div className={`h-[44px] p-2 rounded shadow col-span-2 border border-dashed border-gray-400 cursor-pointer hover:shadow-md bg-white`} key={index}>
                                                    <div className='flex justify-between items-center px-1'>
                                                        <div className='flex items-center'>
                                                            <Building size={18} />
                                                            <p className='text-xl font-medium font-serif ml-2'>{unit.title}</p>
                                                        </div>
                                                        <div className='bg-red-500 text-white text-xs px-2 py-1 rounded cursor-pointer' onClick={() => releaseRental(unit)}>
                                                            Release
                                                        </div>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            <div className='h-screen w-full'>
                <ScrollArea className="w-full min-h-screen overflow-hidden">
                    <div className='w-full min-h-screen bg-gray-100 rounded-md grid grid-cols-12 gap-1'>
                        <div className='col-span-1 bg-white border-r h-screen flex flex-col'>
                            <div className={`shrink-0 px-2 h-[54px] uppercase flex items-center justify-center text-center text-xs font-medium cursor-pointer border-b border-dashed hover:bg-gray-200 bg-gray-50 text-gray-700`} onClick={() => { loadActiveRentals(); }}>
                                Active Rentables
                            </div>
                            <ScrollArea className="w-full flex-grow">
                                <ul>
                                    <li className={`px-2 h-[54px] uppercase flex items-center justify-center text-center text-xs font-medium cursor-pointer border border-dashed ${selCat === 'all' ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200 bg-white'}`} onClick={() => { sortTable('all'); }}>
                                        All CATEGORY
                                    </li>
                                    {
                                        cats.length !== 0 && [...cats].reverse().map((cat, index) => {
                                            return <li className={`px-2 h-[54px] uppercase flex items-center justify-center text-center text-xs font-medium cursor-pointer border border-dashed ${selCat === cat ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200 bg-white'}`} key={index}>
                                                <div className='flex items-center justify-center'>
                                                    <span className='flex-grow' onClick={() => { sortTable(cat); }}>{cat}</span>
                                                </div>
                                            </li>
                                        })
                                    }
                                </ul>
                            </ScrollArea>
                        </div>
                        <div className={`${!isQSR ? "col-span-5" : "col-span-6"}`}>
                            <ScrollArea className='w-full h-screen bg-white rounded'>
                                <div className='px-2 flex items-center space-x-2'>
                                    <input type="text" id="itemSearch" ref={searchARef} onChange={() => { handleChangeForm('itemSearch') }} autoComplete="off" className="my-2 p-2 block w-full h-9 shadow-inner bg-white text-sm border rounded-md outline-none" placeholder="Search by name" />
                                    <input type="text" id="itemCode" ref={searchBRef} onChange={() => { handleChangeForm('itemCode') }} autoComplete="off" className="my-2 p-2 block w-full h-9 shadow-inner bg-white text-sm border rounded-md outline-none" placeholder="Search by code" />
                                </div>
                                <hr />
                                <div className="grid grid-cols-2 gap-2 p-2 overflow-y-auto">
                                    {
                                        menusFilter.length === 0 && <div className='col-span-3'>
                                            <h1 className='text-lg text-center text-prime'>No data found.</h1>
                                        </div>
                                    }
                                    {
                                        menusFilter.length !== 0 && menusFilter.map((item, index) => {
                                            return <div className="flex border border-gray-200 rounded-md h-20 cursor-pointer hover:shadow-md" key={index} onClick={() => { addItem(item); }}>
                                                <div className='w-1 bg-green-800 rounded-tl-md rounded-bl-md'></div>
                                                <div className='flex items-start px-2 py-2'>
                                                    <img src="https://placehold.co/200x200" className=" h-12 w-12 object-cover rounded-md mr-2" alt="" />
                                                    <div className="flex flex-col items-start">
                                                        <div className="font-medium text-gray-800 text-sm">{item.name}</div>
                                                        <span className="font-medium text-sm text-prime">₹ {item.basePrice}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className='h-10 w-full'></div>
                            </ScrollArea>
                        </div>
                        <div className="col-span-3 px-1 bg-white rounded">
                            <div className="flex flex-row items-center justify-between mt-2">
                                <div className="font-bold text-xl">{table !== undefined ? table.title : getPType()}</div>
                            </div>
                            <ScrollArea className="w-full h-[260px] bg-gray-100 rounded mt-2">
                                {
                                    ordItems.length === 0 && <div className='p-2 w-full h-[200px]'>
                                        <p className='text-sm text-prime text-center'>No items added.</p>
                                    </div>
                                }
                                {
                                    ordItems.length !== 0 && ordItems.map((item, index) => {
                                        return <div className="p-1">
                                            <div className="flex flex-row justify-between items-center">
                                                <div className="flex flex-row items-center w-1/2">
                                                    <div className='flex flex-col items-start ml-1'>
                                                        <div className="font-medium text-sm">{item.name}</div>
                                                        <div className='text-xs'>
                                                            {
                                                                item.addons && item.addons.map((addo, index) => {
                                                                    if (index === (item.addons.length - 1)) {
                                                                        return addo.name;
                                                                    } else {
                                                                        return `${addo.name}, `;
                                                                    }
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    {
                                                        item.qty > 1 && <div className="w-[20px] h-[20px] rounded-md bg-gray-300 flex items-center justify-center" onClick={() => { removeQty(item); }}>
                                                            <p>-</p>
                                                        </div>
                                                    }
                                                    {
                                                        item.qty === 1 && <div className="w-[20px] h-[20px] rounded-md bg-red-300 flex items-center justify-center text-white" onClick={() => { removeItem(item); }}>
                                                            <p>x</p>
                                                        </div>
                                                    }
                                                    <span className="font-medium mx-1">{item.qty}</span>
                                                    <div className="w-[20px] h-[20px] rounded-md bg-gray-300 flex items-center justify-center" onClick={() => { addQty(item); }}>
                                                        <p>+</p>
                                                    </div>
                                                </div>
                                                <div className="font-medium text-base w-12 text-center">
                                                    ₹ {(item.price * item.qty)}
                                                </div>
                                            </div>
                                            <hr className='my-1' />
                                        </div>
                                    })
                                }
                            </ScrollArea>
                            <div className="w-full">
                                <div className="pt-2 rounded-md space-y-1">
                                    <hr />
                                    <div className="border-t-2 mt-2 py-2 px-2 flex items-center justify-between">
                                        <span className="font-semibold text-lg">Total</span>
                                        <span className="font-bold text-lg">₹ {getTotal().toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            {
                                terminal === "order" && <div className="w-full mt-2">
                                    <div className="mt-4 flex justify-between space-x-2">
                                        <div className="h-8 rounded-md shadow-lg text-center bg-prime text-white font-medium cursor-pointer flex-grow flex items-center justify-center" onClick={() => { placeOrder(); }}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && "KOT"}
                                        </div>
                                        <div className="h-8 rounded-md shadow-lg text-center bg-ascent text-white font-medium cursor-pointer flex-grow flex items-center justify-center" onClick={() => { placeOrder(); }}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && "KOT & Print"}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                terminal === "update" && <div className="w-full mt-2">
                                    <div className="mt-4 flex justify-between space-x-2">
                                        <div className="h-8 rounded-md shadow-lg text-center bg-prime text-white font-medium cursor-pointer flex-grow flex items-center justify-center" onClick={() => { updateOrder(); }}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && "UPDATE"}
                                        </div>
                                        <div className="h-8 rounded-md shadow-lg text-center bg-ascent text-white font-medium cursor-pointer flex-grow flex items-center justify-center" onClick={() => { updateOrder(); }}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && "UPDATE & PRINT"}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                terminal === "bill" && <div className="w-full mt-2">
                                    <div className="mt-4 flex">
                                        <div className="px-4 py-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer mx-2 flex-grow" onClick={() => { setIsOpen(true); }}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && "GENRATE BILL"}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                terminal === 'settle' && <>
                                    <div className='flex items-center justify-evenly my-6'>
                                        <div className='flex items-center'>
                                            <input id="cash-radio" type="radio" checked={pmode === 'cash'} onChange={() => {
                                                setPMode('cash');
                                            }} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                            <label for="cash-radio" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">CASH</label>
                                        </div>
                                        <div className='flex items-center'>
                                            <input id="upi-radio" type="radio" checked={pmode === 'upi'} onChange={() => {
                                                setPMode('upi');
                                            }} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                            <label for="upi-radio" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">UPI</label>
                                        </div>
                                        <div className='flex items-center'>
                                            <input id="card-radio" type="radio" checked={pmode === 'card'} onChange={() => {
                                                setPMode('card');
                                            }} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                            <label for="card-radio" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">CARD</label>
                                        </div>
                                        <div className='flex items-center'>
                                            <input id="bank-radio" type="radio" checked={pmode === 'bank'} onChange={() => {
                                                setPMode('bank');
                                            }} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                            <label for="bank-radio" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">BANK</label>
                                        </div>
                                        <div className='flex items-center'>
                                            <input id="nc-radio" type="radio" checked={pmode === 'nc'} onChange={() => {
                                                setPMode('nc');
                                            }} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                            <label for="nc-radio" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">NC</label>
                                        </div>
                                    </div>
                                    <div className="w-full mt-2">
                                        <div className="mt-4">
                                            <div className="px-4 py-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer" onClick={() => {
                                                if (isQSR) {
                                                    if (ordItems.length === 0) {
                                                        toast.error('Please add an item.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                                                    } else {
                                                        setIsOpen(true);
                                                    }
                                                } else {
                                                    placeBill();
                                                }
                                            }}>
                                                {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                                {!submit && isQSR ? "GENRATE BILL" : "SETTLE BILL"}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        {
                            !isQSR && <div className='col-span-3'>
                                <div className='flex items-center justify-between p-2'>
                                    <h2 className="text-xl font-medium font-serif truncate text-ascent uppercase">
                                        Orders
                                    </h2>
                                    <div className="font-medium cursor-pointer" onClick={() => { createBill(); }}>
                                        <span className="px-2 py-1 rounded-md bg-red-100 text-prime border border-prime text-sm">Make Bill</span>
                                    </div>
                                </div>
                                <hr />
                                <ScrollArea className="w-full h-screen flex flex-col">
                                    {
                                        orders.length === 0 && <div className='w-full text-prime items-center justify-center mt-8'>
                                            <p className='text-sm font-medium text-center'>No orders found.</p>
                                        </div>
                                    }
                                    {
                                        orders.map((ord) => {
                                            return <div className={`w-full bg-white my-2 px-3 py-3 border rounded-md justify-between cursor-pointer hover:shadow-md ${(selOrd === ord._id || terminal === "bill") ? 'border-prime' : 'border-gray-200'}`} key={ord._id} onClick={() => { selBill(ord); }}>
                                                <div className="font-bold text-gray-800"><b>#{ord.ordid}</b></div>
                                                <hr className='my-1' />
                                                <div className='flex items-center'>
                                                    <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                                    <div className='flex-grow'></div>
                                                    <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                                </div>
                                                <hr className='my-1' />
                                                {
                                                    ord.items.map((item) => {
                                                        return <div className='flex items-center'>
                                                            <p className='text-sm  font-medium text-gray-950'>{item.name}</p>
                                                            <div className='flex-grow'></div>
                                                            <p className='text-sm font-medium'>{item.qty} x ₹ {item.price} </p>
                                                        </div>
                                                    })
                                                }
                                                <hr className='my-1' />
                                                <div className="text-sm">Status: <span className='text-sm font-bold text-prime'>{getOrderStatus(ord.status)}</span></div>
                                            </div>
                                        })
                                    }
                                </ScrollArea>
                            </div>
                        }
                    </div>
                    <div className='h-10 w-full'></div>
                </ScrollArea>
            </div>
        </>
    )
}